<template>
  <div >
  </div>
</template>

<script>
import storage from 'good-storage'

export default {
  name: "linkto",
 created (){
  var url = window.location.href.toString();
  var h=storage.get('historyUrl','').toString()
     if(this.GetUrlParam(url,"type")=="resign"){

  window.location.href="/resign?qiyeId="+(this.GetUrlParam(h,"qiyeId")==undefined?"":this.GetUrlParam(h,"qiyeId"))
   }
     if(this.GetUrlParam(url,"type")=="dologin"){
  window.location.href="/dologin?qiyeId="+(this.GetUrlParam(h,"qiyeId")==undefined?"":this.GetUrlParam(h,"qiyeId"))
   }
},
methods:{
   addOrgToUrl(url,paramName,replaceWith){
    //url字符串添加参数
    //url:路径地址 paramName：参数名 replaceWith：参数值
      if (url.indexOf(paramName) > -1) {
          var re = eval('/(' + paramName + '=)([^&]*)/gi');
          url = url.replace(re, paramName + '=' + replaceWith);
      } else {
          var paraStr = paramName + '=' + replaceWith;

          var idx = url.indexOf('?');
          if (idx < 0)
              url += '?';
          else if (idx >= 0 && idx != url.length - 1)
              url += '&';
          url=url + paraStr;
      }
      return url;
    },
        GetUrlParam(url,paraName) {
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
}
};
</script>
